import { injectDeveloperApi } from '@delmonicos/shared-sdk/libs/emsp/src/clients/redux/back-office/developers.service';
import { baseApi } from '@service/base.api';

export const developerApi = injectDeveloperApi(baseApi);

export const {
  useGetDeveloperQuery,
  useGetDevelopersPaginatedQuery,
  useCreateDeveloperMutation,
  useUpdateDeveloperMutation,
  useDeleteDeveloperMutation,
} = developerApi;
